import type { StandaloneApp } from './sources';

/*
  WARNING: Stage option will redirect all requests and authorizations to stage env
*/

const STAGE = false;
const BYPASS_CACHE = false;

export const CORS_PROXY = 'https://cors-proxy.utils.elfsightcdn.com';

export const NODE_ENV = process.env.NODE_ENV || 'development';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';

if (!process.env.APP_MANIFEST) {
  throw new Error('APP_MANIFEST is required');
}

const APP_MANIFEST = process.env.APP_MANIFEST as {
  name: string;
  alias:
    | 'social-feed'
    | 'linkedin-feed'
    | 'vk-feed'
    | 'rss-feed'
    | 'tiktok-feed'
    | 'tumblr-feed';
  provider?: StandaloneApp;
};

// TODO: Подумать над правильной логикой для linkedin
const STANDALONE_APPS = ['linkedin'];

export const meta = {
  alias: APP_MANIFEST.alias,
  name: APP_MANIFEST.name,
  provider: APP_MANIFEST.provider,
  stage: STAGE && IS_DEVELOPMENT,
  storageURL:
    STAGE && IS_DEVELOPMENT
      ? 'https://storage.elfhome.ru'
      : 'https://storage.elfsight.com',
  dataServiceApiURL:
    STAGE && IS_DEVELOPMENT
      ? 'https://widget-data-stage.elfsight.dev'
      : 'https://widget-data.service.elfsight.com',
  proxyBypassCache: BYPASS_CACHE && IS_DEVELOPMENT,
  isStandalone:
    !!APP_MANIFEST.provider && STANDALONE_APPS.includes(APP_MANIFEST.provider)
};
